module.exports.GLOBAL_CONSTANTS = {
  APP_NAME: "Калькулятор",
  API_URL: "https://api.example.com",
  SPREADSHEET_ID: "1-3mdsuqG9iuRC_CV5Xj07brPK47hEHY9w9eubizjwF4", // ID таблицы

  CATEGORY_NAMES: { //из справочника доставки для перевода
    os: 'Общестрой',
    jbi: 'ЖБИ',
    gaz: 'Газобетон и кирпич',
    ner: 'Нерудные материалы',
    mix: 'Бетон',
    pilmat: 'Пиломатериалы',
    grandline: 'Металлочерепица, профлист и штакетник',
    metall: 'Металл',
  },
  SHEETS: {
    deliverySheet: {
      RANGE: "Доставка!A:I", // Диапазон, соответствующий всем колонкам таблицы
      COLUMNS: {
        CATEGORY: 0, // Категория товара (A)
        DELIVERY_METHOD: 1, // Способы доставки (B)
        ID_BITRIX: 2, // ID битрикса (c)
        WEIGHT_TON: 3, // Кол-во тн (D)
        COST_PER_KM: 4, // За км в руб (E)
        SUPPLY_COST: 5, // Подача (F)
        VOLUME_M3: 6, // Кол-во м3 (G)
        COST_INSIDE_KAD: 7, // Стоимость заезда внутри КАД (H)
        COST_OUTSIDE_KAD: 8, // Стоимость заезда за КАД (I)
        COST_JBI: 9 // Стоимость заезда для ЖБИ (J)
      }
    },
    productionSheet: {
      RANGE: "Производства!A:F",
      COLUMNS: {
        NAME: 0, // Производство
        LATITUDE: 1, //широта
        LONGITUDE: 2, // долгота
        ADDITIONAL_INFO: 3, // Доп. информация
        INN: 4, // ИНН
        REGION: 5 // Регион
      }
    },
    stockSheet: {
      RANGE: "Склад!A:AD", // Диапазон
      COLUMNS: {
        CALCULATOR: 0, // Калькулятор (A)
        CATEGORY: 1, // Категория (B)
        MANUFACTURER: 2, // Производство (C)
        NOMENCLATURE: 3, // Номенклатура (D)
        PRICE_CASH: 4, // Цена нал ПРОДАВАТЬ (E)
        PRICE_NONCASH: 5, // Цена безнал ПРОДАВАТЬ (F)
        PRICE_UPDATE_DATE: 6, // Дата обновления цен (G)
        WEIGHT_TONS: 7, // Масса изделия в тн (H)
        VOLUME_CUBIC: 8, // Объем изделий в м3 (I)
        BASE_UNIT: 9, // Базовая единица измерения (J)
        BITRIX_ID: 10, // Id bitrix (K)
        DENSITY: 11, // Плотность (L)
        ANALOGY: 12, // Для аналогии (M)
        OSB_THICKNESS_MM: 13, // Толщина осб, мм (N)
        AREA_INSULATION: 14, // м2 утепл (O)
        SHEETS_INSULATION: 15, // листы утепл (P)
        INSULATION_THICKNESS: 16, // толщина утепл. (Q)
        DESCRIPTION: 17, // Описание (R)
        BITRIX_PRODUCT: 18, // товар в битриксе (S)
        PALLET_UNITS: 19, // поддон в ед (T)
        SHALANDA_PALLETS: 20, // шаланда кол-во поддонов (U)
        MANIPULATOR_10T: 21, // манипулятор 10т (V)
        MANIPULATOR_TRAILER: 22, // манипулятор с прицепом (W)
        WIDTH: 23, // ширина (X)
        DENSITY_REPEAT: 24, // плотность (повтор) (Y)
        UNITS_PER_PALLET: 25, // кол-во шт на поддоне (Z)
        FORMAT: 26, // формат (AA)
        STRENGTH: 27, // прочность (AB)
        AREA_OSB: 28, // м2 OSB (AC)
        REGION: 29, // регион производства (AD)
      }
    },
    deliveryGazSheet: {
      RANGE: "Доставка_Газ!A:O",
      COLUMNS: {
        PRODUCTION: 0, // Производства (A)
        COORDINATES: 1, // Координаты_Производства (B)
        LOCATION_HOURS: 2, // Нас пункт и часы работы (C)
        RATE_SHALANDA: 3, // ставка (шаланда) (D)
        MIN_COST_SHALANDA: 4, // мин стоимость (шаланда) (E)
        DELIVERY_SHALANDA: 5, // Подача (шаланда) (F)
        UNLOADING_SHALANDA: 6, // Разгрузка (шаланда) (G)
        RATE_MANIPULATOR_10T: 7, // ставка (манипулятор 10т) (H)
        MIN_COST_MANIPULATOR_10T: 8, // мин стоимость (манипулятор 10т) (I)
        DELIVERY_MANIPULATOR_10T: 9, // Подача (манипулятор 10т) (J)
        UNLOADING_MANIPULATOR_10T: 10, // Разгрузка (манипулятор 10т) (K)
        RATE_MANIPULATOR_TRAILER: 11, // ставка (манипулятор с прицепом) (L)
        MIN_COST_MANIPULATOR_TRAILER: 12, // мин стоимость (манипулятор с прицепом) (M)
        DELIVERY_MANIPULATOR_TRAILER: 13, // Подача (манипулятор с прицепом) (N)
        UNLOADING_MANIPULATOR_TRAILER: 14 // Разгрузка (манипулятор с прицепом) (O)
      }
    },
    deliveryJBI_MSK: {
      RANGE: "Справочник_доставок_МСК!A:F",
      COLUMNS: {
        DELIVERY_METHOD: 0, // Название единицы техники (A)
        WEIGHT_TON: 1, // Максимальная вместимость (B)
        SUPPLY_COST: 2, // Минималка по городу (C)
        COST_OUTSIDE_KAD: 3, // Стоимость за КМ за КАД'ом (D)
        COST_JBI: 4, // Стоимость одного заезда (E)
        ID_BITRIX: 5, // ID битрикса (F)
      }

    },
    center: {
      RANGE: "Централизация!A:F",
      COLUMNS: {
        PRODUCTION: 0, // Производство (A)
        TECHNIC: 1, // Вид техники (B)
        MIN: 2, // Минималка (C)
        NUMBER_KM: 3, // До скольки км (D)
        STAVKA_ZA_KM: 4, // Ставка за км (E)
        PODACHA: 5, // Подача (F)
        NO_ZAEXAT: 6, // Не заехать (E)
      }
    },
    deliveryNerud: {
      RANGE: "Доставка_неруд!A:Z",
      COLUMNS: {
        DELIVERY_METHOD: 0, // Метод доставки (А)
        RATE_KM: 1, // Ставка за км (B)
        VOLUME: 2, // Вместимость м3 (C)
      }
    },
    // В файле constants.js
    mixZavod: {
      RANGE: "'Миксера на заводах'!A:F",
      COLUMNS: {
        PRODUCTION: 0, // Название производства
        VOLUME_7: 1,   // Наличие миксера 7 м³
        VOLUME_8: 2,   // Наличие миксера 8 м³
        VOLUME_9: 3,   // Наличие миксера 9 м³
        VOLUME_10: 4,  // Наличие миксера 10 м³
        VOLUME_12: 5   // Наличие миксера 12 м³
      }
    },
    specialPoints: {
      RANGE: "'Особые точки бетона'!A:D",
      COLUMNS: {
        NAME_POINT: 0, // Название точки (А)
        COORDINATES: 1, // Координаты точки (B)
        RADIUS_KM: 2, // КМ от нее (C)
        MIN_COST_CUB: 3, // Минимальная цена за куб доставки (D)
      }
    },
  },
};

// Фолбэк-ID для каскадного выбора логиста. Меняются только по согласованию с РП логистики.
// Эти константы продублированы в server-modules/shared/logistics/constants.js
// для использования на backend'е (src/ не деплоится в бэковую папку /server/).
// При изменении значения — менять в обоих местах.
module.exports.LOGIST_FALLBACK_TAG_MISS_ID = 8462;       // Гильмутдинова Диана — fallback подотдел не смапился
// module.exports.LOGIST_FALLBACK_TAG_MISS_ID = 2149;       // Рябов Никита — fallback подотдел не смапился
module.exports.LOGIST_FALLBACK_EMPTY_CASCADE_ID = 1878;  // Сиваков Дмитрий — fallback каскад пуст
module.exports.DEPARTMENT_ROOT_SUPPLY_ID = '15';         // Отдел снабжения (корень дерева логистов)
